import { PriorityKey } from '../catalog';

// Poste manipulé pendant l'onboarding (catalogue ou personnalisé).
export interface DraftPost {
  id: string; // clé locale : clé du catalogue ou « custom-N »
  key: string | null;
  name: string;
  hint: string;
  weight: number;
  priority: PriorityKey | null;
  perGuest?: boolean;
}

const PRIORITY_BOOST = 1.3;
const ROUND_TO = 50;
// Nombre d'invités pour lequel les parts usuelles sont calibrées
const REFERENCE_GUESTS = 90;

// Poids d'un poste : part usuelle, ajustée au nombre d'invités pour ce qui se
// paie au couvert, et augmentée pour les priorités.
function weightOf(p: DraftPost, guests: number, priorities: PriorityKey[]) {
  let w = p.weight;
  if (p.perGuest) w *= Math.min(1.35, Math.max(0.7, guests / REFERENCE_GUESTS));
  if (p.priority && priorities.includes(p.priority)) w *= PRIORITY_BOOST;
  return w;
}

// Répartition automatique du budget sur les postes, arrondie à 50 €.
// L'écart d'arrondi va aux imprévus (ou au premier poste).
export function autoAllocate(total: number, posts: DraftPost[], guests: number, priorities: PriorityKey[]) {
  const result: Record<string, number> = {};
  if (!posts.length) return result;
  const sum = posts.reduce((s, p) => s + weightOf(p, guests, priorities), 0) || 1;
  for (const p of posts) {
    result[p.id] = Math.round((total * weightOf(p, guests, priorities)) / sum / ROUND_TO) * ROUND_TO;
  }
  const gap = total - Object.values(result).reduce((s, n) => s + n, 0);
  const sink = posts.find((p) => p.key === 'imprevus') ?? posts[0];
  result[sink.id] += gap;
  return result;
}

// Teinte d'un poste dans la barre de répartition (du plus foncé au plus clair).
const TONES = [88, 72, 58, 46, 36, 28, 22, 17, 13, 10, 8, 6];
export const toneOf = (i: number) => `color-mix(in oklab, var(--primary) ${TONES[i % TONES.length]}%, var(--n-150))`;
